import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation updateMallMutation($input: UpdateMallInput!) {
    updateMall(input: $input) {
      mall {
        id
        ...MallEdit_mall
        ...MallShow_mall
      }
      errors {
        key
        messages
      }
    }
  }
`;

const getUploadables = ({ smallMap, largeMap }) => {
  if (!smallMap && !largeMap) {
    return null;
  }

  const uploadables = {};

  if (smallMap) {
    uploadables.mallSmallMap = smallMap;
  }
  if (largeMap) {
    uploadables.mallLargeMap = largeMap;
  }
  return uploadables;
};

const updateMall = (environment, attributes, args = {}) => {
  const { smallMap, largeMap, ...input } = attributes;

  return commit(environment, {
    mutation,
    uploadables: getUploadables({ smallMap, largeMap }),
    variables: {
      input,
    },
    optimisticResponse: {
      updateMall: {
        mall: input,
      },
    },
    ...args,
  });
};

export default updateMall;
